import React, { FC } from 'react'
import classNames from 'classnames'
import { makeStyles } from 'transfix-ui/core'

const useCarrierTrailerStyles = makeStyles(theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '42fr 276fr 24fr',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    alignItems: 'center',
    gap: 3,
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '180fr 350fr 468fr 160fr 20fr',
    },
    [theme.breakpoints.up('xl')]: {
      gridTemplateColumns: '90fr 70fr 230fr 228fr 220fr 200fr 20fr',
    },
  },
  trailerNumber: {
    order: 1,
    gridArea: '1 / 2 / 2 / 3',
    [theme.breakpoints.up('md')]: {
      gridArea: '1 / 1 / 3 / 2',
    },
    [theme.breakpoints.up('xl')]: {
      gridArea: 'auto',
      display: 'block',
    },
  },
  stopType: {
    order: 3,
    gridArea: '1 / 1 / 3 / 2',
    [theme.breakpoints.up('md')]: {
      order: 2,
      display: 'none',
    },
    [theme.breakpoints.up('xl')]: {
      order: 3,
      gridArea: 'auto',
      display: 'block',
    },
  },
  nextAppointment: {
    order: 4,
    gridArea: '2 / 2 / 4 / 3',
    [theme.breakpoints.up('md')]: {
      order: 7,
      gridArea: '2 / 2 / 3 / 3',
    },
    [theme.breakpoints.up('xl')]: {
      order: 4,
      gridArea: 'auto',
    },
  },
  lane: {
    order: 5,
    gridArea: '4 / 2 / 5 / 3',
    [theme.breakpoints.up('md')]: {
      order: 3,
      gridArea: '1 / 3 / 4 / 4',
    },
    [theme.breakpoints.up('xl')]: {
      order: 5,
      gridArea: 'auto',
    },
  },
  shipment: {
    order: 6,
    gridArea: '5 / 2 / 6 / 3',
    [theme.breakpoints.up('md')]: {
      order: 8,
      gridArea: '1 / 2 / 2 / 3',
    },
    [theme.breakpoints.up('xl')]: {
      order: 6,
      gridArea: 'auto',
    },
  },
  location: {
    order: 7,
    gridArea: '6 / 2 / 7 / 3',
    [theme.breakpoints.up('md')]: {
      order: 4,
      gridArea: '1 / 4 / 4 / 5',
    },
    [theme.breakpoints.up('xl')]: {
      order: 7,
      gridArea: 'auto',
    },
  },
  actions: {
    order: 8,
    gridArea: '1 / 3 / 2 / 3',
    [theme.breakpoints.up('md')]: {
      order: 4,
      gridArea: '1 / 5 / 6 / 7',
    },
    [theme.breakpoints.up('xl')]: {
      order: 8,
      gridArea: 'auto',
    },
  },
}))

type TCarrierTrailerRowContainerProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>

const CarrierTrailerRowContainer: FC<TCarrierTrailerRowContainerProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useCarrierTrailerStyles()
  return (
    <div {...props} className={classNames(styles.container, className)}>
      {children}
    </div>
  )
}

export const TrailerNumberContainer: FC<TCarrierTrailerRowContainerProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useCarrierTrailerStyles()
  return (
    <div {...props} className={classNames(styles.trailerNumber, className)}>
      {children}
    </div>
  )
}

export const StopTypeContainer: FC<TCarrierTrailerRowContainerProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useCarrierTrailerStyles()
  return (
    <div {...props} className={classNames(styles.stopType, className)}>
      {children}
    </div>
  )
}

export const NextAppointmentContainer: FC<TCarrierTrailerRowContainerProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useCarrierTrailerStyles()
  return (
    <div {...props} className={classNames(styles.nextAppointment, className)}>
      {children}
    </div>
  )
}

export const LaneContainer: FC<TCarrierTrailerRowContainerProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useCarrierTrailerStyles()
  return (
    <div {...props} className={classNames(styles.lane, className)}>
      {children}
    </div>
  )
}

export const ShipmentContainer: FC<TCarrierTrailerRowContainerProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useCarrierTrailerStyles()
  return (
    <div {...props} className={classNames(styles.shipment, className)}>
      {children}
    </div>
  )
}

export const LocationContainer: FC<TCarrierTrailerRowContainerProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useCarrierTrailerStyles()
  return (
    <div {...props} className={classNames(styles.location, className)}>
      {children}
    </div>
  )
}

export const ActionsContainer: FC<TCarrierTrailerRowContainerProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useCarrierTrailerStyles()
  return (
    <div {...props} className={classNames(styles.actions, className)}>
      {children}
    </div>
  )
}

export default CarrierTrailerRowContainer
